import { render } from "./ResetPassword.vue?vue&type=template&id=4d5e289e&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Authentication/ResetPassword/ResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d5e289e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d5e289e', __exports__)) {
    api.reload('4d5e289e', __exports__)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=4d5e289e&ts=true", () => {
    api.rerender('4d5e289e', render)
  })

}


export default __exports__